import HeroBg from "public/networkDigitalTwins/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Simulate and improve your network today",
    link: "contact-us",
  },
  title: "Virtual Network Simulations for Performance & Security",
  desc: "Test, tune, and secure your infrastructure with advanced virtual network simulations built for real-world scenarios.",
  image: HeroBg,
  cmlPowered: true,
};
